<template>
  <div>
    <div v-if="withLoader" class="flex size-8 min-h-8 min-w-8 items-center justify-center rounded-full bg-primary-05">
      <UiProgressSpinner class="!size-5 !border" />
    </div>
    <div class="flex flex-col gap-2">
      <p class="text-subhead-4">{{ $t('importing_data') }}</p>
      <div class="text-body-2">
        <span class="text-subhead-4">{{ rowsCount }} {{ $t('rows') }}</span>
        {{ $t('are_being_prepared_for_importing') }}
      </div>
      <div class="relative h-1 min-h-1 w-full rounded bg-black-10">
        <div class="absolute h-full rounded bg-primary-100" :style="{ width: `${progressPercent}%` }"></div>
      </div>
      <p class="text-body-2 self-end">{{ rowsPreparedCount }}/{{ rowsCount }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  rowsCount: number
  rowsPreparedCount: number
  withLoader?: boolean
}>()

const progressPercent = computed(() => {
  if (props.rowsCount <= 0) return 0
  const raw = (props.rowsPreparedCount / props.rowsCount) * 100
  return Math.min(100, Math.max(0, raw))
})
</script>
